import { SuggestedSeriesDismissDialog } from 'src/component/lets-get-moving/suggested-series-dismiss-dialog'
import { SuggestedSectionTitle } from 'src/component/lets-get-moving/suggested-section-title'
import { SeeAll } from 'src/component/ui/see-all'
import { SeriesCardKeepGoing, SeriesCardKeepGoingSkeleton } from 'src/component/ui/series-card'
import { useCancelProgrammeDialog } from 'src/hook/use-cancel-programme-dialog'
import { useMyStartedProgrammesFromLibrary } from 'src/hook/use-programmes'
import { toasterUtil } from 'src/util/toaster-util'
import React from 'react'
import { Col, Row } from 'react-bootstrap'

const HOMEPAGE_PAGE = 1
const HOMEPAGE_PAGE_SIZE = 3

export const KeepGoing = (): React.ReactElement => {
  const { requestCancel, dialogProps } = useCancelProgrammeDialog()
  const { data, isLoading, isSuccess, isError } = useMyStartedProgrammesFromLibrary(
    { page: HOMEPAGE_PAGE, pageSize: HOMEPAGE_PAGE_SIZE },
    {
      onError: () => {
        toasterUtil.error('We could not load your series in progress. Please try again.')
      },
    },
  )

  if (isLoading && !data) {
    return (
      <div data-testid="keep-going-section">
        <div className="mb-8 lg:mb-10">
          <SuggestedSectionTitle>Keep going</SuggestedSectionTitle>
        </div>
        <Row>
          {Array.from({ length: HOMEPAGE_PAGE_SIZE }).map((_, index) => (
            <Col xs={12} lg={4} key={index} className="mb-4">
              <SeriesCardKeepGoingSkeleton />
            </Col>
          ))}
        </Row>
      </div>
    )
  }

  if (isError) {
    return <></>
  }

  const items = data?.data ?? []
  const totalSize = data?.totalSize ?? 0

  if (isSuccess && items.length === 0) {
    return <></>
  }

  const showSeeAll = totalSize > HOMEPAGE_PAGE_SIZE

  return (
    <div data-testid="keep-going-section">
      <div className="flex flex-wrap justify-between items-center gap-4 mb-8 lg:mb-10">
        <SuggestedSectionTitle>Keep going</SuggestedSectionTitle>
        {showSeeAll ? <SeeAll seeAllLink="/keep-going" theme="dark" /> : null}
      </div>
      <Row>
        {items.map((hp) => (
          <Col xs={12} lg={4} key={hp.programme.id} className="mb-4">
            <SeriesCardKeepGoing series={hp.programme} onCancelSeriesClick={() => requestCancel(hp.programme)} />
          </Col>
        ))}
      </Row>
      <SuggestedSeriesDismissDialog {...dialogProps} />
    </div>
  )
}
